import classnames from 'classnames';
import LocalizedNoIndexLink from 'components/LocalizedNoIndexLink';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

const CSS = require('./FilterPopoverTrigger.module.scss');

interface FilterPopoverTriggerProps {
  destination: string;
  text: string;
  togglePopover: () => void;
  isActive: boolean;
  show?: boolean;
  children: React.ReactNode;
}

function FilterPopoverTrigger({
  destination,
  text,
  togglePopover,
  isActive,
  show,
  children,
}: FilterPopoverTriggerProps) {
  const isMobile = useIsMobile();
  const classes = classnames(CSS.FilterButton, {
    [CSS.FilterButtonIsActive]: isActive,
  });

  return (
    <div>
      {isMobile ? (
        <LocalizedNoIndexLink
          className={classes}
          to={{ pathname: destination, state: { modal: true } }}
        >
          {text}
        </LocalizedNoIndexLink>
      ) : (
        <button className={classes} onClick={togglePopover}>
          {text}
        </button>
      )}
      {show ? children : null}
    </div>
  );
}

export default FilterPopoverTrigger;
